import { footerColumns } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer id="footer" className="bg-secondary-900 text-background-100">
      <div className="mx-auto max-w-[1360px] px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading font-bold text-lg">
                18
              </span>
              <span className="font-heading font-bold text-xl text-background-50">18爆料网</span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-background-200 max-w-md">
              18爆料网事件深扒专栏，把散落的爆料线索拼成完整时间线。实锤证据逐条归档、逐条校验，
              让每一条爆料都有出处，让每一次梳理都经得起复盘。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {['事件深扒', '实锤证据', '事件全梳理', '真相揭秘'].map((k) => (
                <span
                  key={k}
                  className="px-3 py-1.5 rounded-full text-xs bg-secondary-800 text-background-200 border border-secondary-700"
                >
                  {k}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {footerColumns.map((col) => (
              <div key={col.title}>
                <h4 className="font-heading text-sm font-semibold text-background-50 tracking-wide">{col.title}</h4>
                <ul className="mt-4 space-y-2.5">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-sm text-background-300 hover:text-accent-400 transition-colors"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-background-300">
          <p>© 2026 18爆料网 · 本站内容为演示展示，人物与事件均为虚构整理。</p>
          <div className="flex items-center gap-5">
            <a href="#top" className="hover:text-accent-400 transition-colors">
              回到顶部
            </a>
            <span className="flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shield-check-line text-[13px]" />
              </span>
              内容已做来源标注
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}